export default __webpack_public_path__ + "static/media/1.7227d0c0.png";